import { normalisePickNameOverride } from './pick-name.js';
/**
 * Fixture display label — canonical resolver.
 *
 * Player-facing fixture text is `displayNameOverride` when meaningful, otherwise
 * the fixture `name` from the feed (e.g. "Belgium vs Spain").
 */
export const resolveFixtureLabel = (record) => normalisePickNameOverride(record.displayNameOverride) ?? record.name;
//# sourceMappingURL=fixture-label.js.map